import { DurationType, RiskChance } from 'src/Enum/GoalsAndOperationalPlans';
import {
  IAsset,
  ICompletedSection,
  IIntroduction,
  IOtherDescription,
  IRemark,
} from './utils';
import useAxios from 'axios-hooks';

interface IOverview {
  introduction?: IIntroduction;
  remark?: IRemark;
}

interface IRelateItem {
  infoCategoryMasterDataId: number;
  nameTh?: string | null;
  nameEn?: string | null;
}

interface Indicator {
  id?: number;
  criteriaTh?: string;
  criteriaEn?: string;
}

interface IOperationPlan {
  id?: number;
  detailTh?: string;
  detailEn?: string;
  durationType: DurationType | null;
  startDate?: Date | null;
  endDate?: Date | null;
  indicators?: Indicator[];
}

interface IRisk {
  id?: number;
  nameTh?: string;
  nameEn?: string;
  relateRisks?: IRelateItem[];
  chance: RiskChance | null;
  characteristicTh?: string | null;
  characteristicEn?: string | null;
  measurementTh?: string | null;
  measurementEn?: string | null;
}

interface IRiskManagement extends IOverview {
  risks: IRisk[];
}

export interface IGoal {
  id?: number;
  sequence: number;
  nameTh?: string;
  nameEn?: string;
  relateGoals: IRelateItem[];
  descriptionTh?: string;
  descriptionEn?: string;
  operationPlans?: IOperationPlan[];
  assets?: IAsset[] | null;
  riskManagement: IRiskManagement;
}

export interface ICompanyValueIncreasePlans extends IOverview {
  goals?: IGoal[];
}

export interface IGoalsAndOperationalPlans {
  overview?: IOverview;
  companyValueIncreasePlans: ICompanyValueIncreasePlans;
  otherDescriptions?: IOtherDescription[] | null;
  completedSection: ICompletedSection;
}

export const useSaveGoalsAndOperationalPlans = (
  reportId?: string,
  payload?: IGoalsAndOperationalPlans
) => {
  return useAxios<IGoalsAndOperationalPlans>(
    {
      url: `/goals-and-operation-plans/${reportId}`,
      data: payload,
      method: 'POST',
    },
    { manual: true }
  );
};

export const useGetGoalsAndOperationalPlans = (reportId?: string) => {
  return useAxios<IGoalsAndOperationalPlans>({
    url: `/goals-and-operation-plans/${reportId}`,
  });
};
